var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1019.5 -917.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,.5H0v-1H20Z",
    transform: "translate(1019.5 927.5)",
    fill: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,.5H0v-1H20Z",
    transform: "translate(1029.5 917.5) rotate(90)",
    fill: "#dfe1e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.b0f81992069476d86f59c56dbb302fb1.svg";
export { ForwardRef as ReactComponent };